import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar1 from './layout/navbar/Navbar1';
import { FiSliders } from 'react-icons/fi';
const EventTable = () => {
  // const { _id, game, player, poolAmount, status } = props.history;

  const [history, setHistory] = useState([]);

  useEffect(() => {
    const getMyEvent = async () => {
      try {
        const res = await axios.get('/api/v1/stakes');

        setHistory(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getMyEvent();
  }, []);

  return (
    <>
      <div id='eventhistory' className='py-5'>
        <div style={{}} className='py-4'>
          <div className='d-flex justify-content-center'>
            <table style={{ width: '87vw' }} className='text-center'>
              <thead
                style={{
                  backgroundColor: 'rgba(196, 196, 196, 0.5)',
                  fontSize: '1.125rem',
                }}
                className=''
              >
                <tr className='text-center'>
                  <th style={{}} className='fw-bold py-3'>
                    Game Name
                  </th>
                  <th style={{}} className='fw-bold'>
                    Player Name
                  </th>
                  <th style={{}} className='fw-bold'>
                    Pool Amount
                  </th>
                  <th style={{}} className='fw-bold'>
                    Status
                  </th>
                </tr>
              </thead>
              {history.map(
                (his) => (
                  // {_id, event, team1, team2, team, poolAmount} = his,
                  // console.log(his.team),
                  console.log(his.event.team1),
                  (
                    // {if(his.team === his.team1._id ){
                    //   const team = his.team1.name
                    // }else{
                    //   const team = team2.name
                    // }}

                    <tbody key={his._id}>
                      <tr className='border-bottom'>
                        <td className='py-3'>
                          <div>
                            {his.event.game}
                            <br />
                            (Shutout Stack, Right Hand Match)
                          </div>
                        </td>
                        <td className=''>
                          <p className='pt-3'>{his.player}</p>
                        </td>
                        <td
                          style={{ color: '#545558' }}
                          className='ms-md-5 ps-md-4'
                        >
                          {his.event.poolAmount}
                        </td>
                        <td style={{ color: '#545558' }} className='ps-2'>
                          Status
                        </td>
                      </tr>
                    </tbody>
                  )
                )
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventTable;
